import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

interface NotificationResponse {
    message: string;
    pagination: {
        currentPage: number;
        pageSize: number;
        totalNotifications: number;
        totalPages: number;
    };
    unreadCount: number;
    unreadNotifications: Notification[];
    count: number;
    notifications: Notification[];
}

interface Notification {
    id: number;
    moduleId: number;
    moduleName: string;
    title: string;
    description: string;
    visible: boolean;
    created_At: string;
}


interface MarkVisibleRequest {
    notificationIds: number[];
}

interface MarkVisibleResponse {
    message: string;
    updatedCount: number;
    updatedIds: number[];
    notFoundIds: number[] | null;
}

export const getNotifications = async (
    supplierId: number, 
    page: number = 1, 
    pageSize: number = 10
): Promise<NotificationResponse> => {
    try {
        const response: AxiosResponse<NotificationResponse> = await axiosInstance.get(
            `/Notifications/GetNotifications/${supplierId}`,
            {
                params: { page, pageSize }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error al obtener notificaciones:', error);
        throw error;
    }
};

export const markNotificationsAsVisible = async (
    notificationIds: number[]
): Promise<MarkVisibleResponse> => {
    try {
        const response: AxiosResponse<MarkVisibleResponse> = await axiosInstance.put(
            '/Notifications/MarkVisibleNotifications',
            { notificationIds } as MarkVisibleRequest
        );
        return response.data;
    } catch (error) {
        console.error('Error al marcar notificaciones como vistas:', error);
        throw error;
    }
};
